import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import PictureHero from "components/PictureHero/PictureHero.jsx";
import QuoteFact from "components/QuoteFact/QuoteFact.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

import columns from "assets/img/columns.jpg";
import athena from "data/athena.json";
import votingFunds from "data/voting-funds.json";

import facts from "data/facts.json";
import quotes from "data/quotes.json";

import Columns from "components/Image/Columns.jsx";
import WomanOnBridge from "components/Image/WomanOnBridge.jsx";

class ProductSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div id="products" className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12}>
            <h2 className={classes.title}>
            Our Products
            <br/>
            <small className={classes.smallTitle}><span className={classes.inlineBlock}>Change corporations. </span> <span className={classes.inlineBlock}>Change the world.</span></small>
            </h2>
          </GridItem>
          <GridItem xs={12}>
          <PictureHero id="athena" BackgroundImage={WomanOnBridge} imageLeft hero={athena} waitlistBar listIds={[23, 30]}/>
          <QuoteFact quote={quotes.lewis} facts={[facts.generalElectionVotingRate, facts.proxyVotingRate]}/>
          <PictureHero id="votingfunds" BackgroundImage={Columns} imageRight hero={votingFunds} waitlistBar listIds={[24, 30]}/>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);
